import React, { useContext, useEffect, useState } from 'react';
import { LangContext } from '../../contexts/langContext';
import { SocialContext } from '../../contexts/socialContext';
import { StateContext } from '../../contexts/stateContext';
import { ASTRO_SUMMARY_SECTIONS, AstroSummary } from '../Edu/AstroSummary';
import { getAstrology, isLiveHoroscope } from '../Edu/utilsAstro';
import { Avatar } from '../UiKit/Avatar';
import { AvatarName } from '../UiKit/AvatarName';
import { ensureAvatarCity } from '../utilsGeo';

const PHS_ITEM_CLASS = 'x_phs_item1 x_phs_item1--100 x_edu_penta_oneperson';

const getMemberHoroscope = async (avatar) => {
  if (isLiveHoroscope(avatar?.astro)) return avatar.astro;
  if (!avatar?.dob && !avatar?.design?.meta?.personality) return null;
  try {
    const avatarWithCity = await ensureAvatarCity(avatar);
    if (!avatarWithCity?.aggr?.city?.location) return null;
    return getAstrology(avatarWithCity)?.horoscope || null;
  } catch {
    return null;
  }
};

export const PentaAstro = React.memo((props) => {
  const { penta } = { ...props };

  const context = { ...useContext(SocialContext), ...useContext(StateContext), ...useContext(LangContext) };
  const $ui = context.$ui;

  const compareColumnWidth = `${(100 / penta.members.length)}%`;
  const [horoscopes, setHoroscopes] = useState({});

  useEffect(() => {
    let cancelled = false;

    const run = async () => {
      const entries = await Promise.all(
        penta.members.map(async (oneMember) => {
          const horoscope = await getMemberHoroscope(oneMember.avatar);
          return [oneMember.avatar.token, horoscope];
        })
      );
      if (cancelled) return;
      setHoroscopes(Object.fromEntries(entries));
    };

    run();
    return () => { cancelled = true; };
  }, [
    penta.token,
    penta.members.map((m) => `${m.avatar.token}:${m.avatar?.dob}:${m.avatar?.city_id}:${m.avatar?.aggr?.city?.location}:${isLiveHoroscope(m.avatar?.astro)}`).join('|'),
  ]);

  return (
    <>
      <div className="x_edu_content_title x_edu_content_title--group x_edu_content_title--sticky">
        <div className="x_edu_content_h x_edu_content_h--2">
          {$ui('popinfo_astro_title')}
        </div>
      </div>

      <div className="x_edu_content x_edu_content--penta x_edu_content--penta_astro">
        <div className="x_edu_content_inner">
          <div className="_fv _fgap0">
            <div className="x_edu_penta_persons">
              {penta.members.map((oneMember) => (
                <div
                  key={`astro_head_${oneMember.avatar.token}`}
                  className="x_edu_penta_oneperson"
                  style={{ flexBasis: compareColumnWidth }}
                >
                  <div className="x_edu_channels">
                    <div className="x_edu_h2 x_edu_h2--sticky">
                      <span className="x_ava_inline0">
                        <span className="x_ava_inline" style={{ display: 'inline-flex' }}>
                          <Avatar style={{ fontSize: '1em' }} avatar={oneMember.avatar} />
                        </span>
                        <span className={`x_ava_inline_name x_ava_inline_name--${oneMember.avatar.design.type.toLowerCase()}`}>
                          <AvatarName avatar={oneMember.avatar} />
                        </span>
                      </span>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            <div className="_fv _fgap1">
              {ASTRO_SUMMARY_SECTIONS.map((section) => (
                <div className="x_edu_penta_persons" key={`astro_${penta.token}_${section}`}>
                  {penta.members.map((oneMember) => {
                    const horoscope = horoscopes[oneMember.avatar.token];
                    return (
                      <div
                        className="x_edu_penta_oneperson _fgap1"
                        key={`${section}_${oneMember.avatar.token}`}
                        style={{ flexBasis: compareColumnWidth }}
                      >
                        {horoscope ? (
                          <AstroSummary
                            horoscope={horoscope}
                            only={section}
                            itemClassName={PHS_ITEM_CLASS}
                          />
                        ) : (
                          <div className={PHS_ITEM_CLASS} />
                        )}
                      </div>
                    );
                  })}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
});
